import { useStaticQuery } from 'gatsby';
export var useDbQuery = function useDbQuery() {
  try {
    var data = useStaticQuery("1635659820");
    return JSON.parse(data.doczDb.db);
  } catch (err) {
    console.error(err);
    console.error('Error when parsing docz database');
    return {};
  }
};

if (typeof useDbQuery !== 'undefined' && useDbQuery && useDbQuery === Object(useDbQuery) && Object.isExtensible(useDbQuery) && !useDbQuery.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useDbQuery, '__filemeta', {
    configurable: true,
    value: {
      name: "useDbQuery",
      filename: "node_modules/gatsby-theme-docz/src/hooks/useDbQuery.js"
    }
  });
}